import { createContext, useContext, useState, useCallback } from "react"; 
import SingleToast from "../components/ui/SingleToast";

const UIContext = createContext();

const UIProvider = ({ children }) => {  
    const [permissions, setPermissions] = useState(null);
    const [profile, setProfile] = useState(null);
    const [segmentTitle, setSegmentTitle] = useState("");
    const [notificationsList, setNotificationsList] = useState([]);
    const [status, setStatus] = useState("idle"); // "idle", "loading", "success", "error"
	  const [toastMessage, setToastMessage] = useState([]); 
    const [newNotification, setNewNotification] = useState(false);

	const addToastMessage = (d, timeout = 3000) => {
    const id = Date.now();
		setToastMessage((toastMessage) => [
			{
				...d,
				id: id,
			},
			...toastMessage,
		]);
    setTimeout(() => {
        removeToast(id);
    }, timeout);
	};

	const removeToast = useCallback((id) => {
		setToastMessage((prevToasts) =>
			prevToasts.filter((toast) => toast.id !== id)
		);
	}, []);
  const addNotification = (d) => {
		setNotificationsList([...notificationsList, d]);
	};

	return (
    <UIContext.Provider
      value={{
        addToastMessage,
        profile,
        setProfile,
        status,
        setStatus,
        setPermissions,
        setNewNotification,
				addNotification,
        permissions,
        segmentTitle,
				setSegmentTitle,
      }}
    >
      {toastMessage.length > 0 && (
        <div
          className={`
                    fixed top-5 right-2 z-[99999999] 
                  `}
        >
          {toastMessage.map((t, i) => (
            <SingleToast data={t} key={i} removeToast={removeToast} />
          ))}
        </div>
      )}
      {children}
    </UIContext.Provider>
  );
};

const useUI = () => {
	const context = useContext(UIContext);
	if (!context) {
		throw new Error("Curate Provider error.");
	}
	return context;
};


export { UIProvider, useUI };